import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs uppercase tracking-[0.28em] text-gold mb-5">{children}</p>
);

export const SectionHeader = ({ eyebrow, title, sub, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 className="font-serif text-4xl sm:text-5xl font-semibold leading-tight text-ivory">{title}</h2>
    {sub && <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-400">{sub}</p>}
  </Reveal>
);
